import { GridSortDirection, GridSortModel } from '@mui/x-data-grid-pro';

import { OrderDirection } from '@/types/schema';

import type { OrderType } from '../hooks/useDataGridSort';

/**
 * Converts GraphQL order array to DataGrid sortModel format
 */
export function convertOrderToSortModel<TField extends string>(
  orderBy: OrderType<TField>[],
  fieldToColumnField: Record<TField, string>
): GridSortModel {
  if (orderBy.length === 0) return [];

  const currentSort = orderBy[0];
  if (!currentSort || !currentSort.direction) return [];

  const columnField = fieldToColumnField[currentSort.field];
  if (!columnField) return [];

  const sortDirection: GridSortDirection =
    currentSort.direction === OrderDirection.Asc ? 'asc' : 'desc';

  return [
    {
      field: columnField,
      sort: sortDirection,
    },
  ];
}
